export default __webpack_public_path__ + "static/media/graignes15.6fed9ab5.jpg";